<template>
  <div class="card" style="min-height: 200px">
    <div class="table-responsive">
      <table class="table">
        <thead>
        <tr>
          <th>Date</th>
          <th>Invoice Number</th>
          <th class="text-right">Invoice Amount</th>
          <th>Customer Name</th>
          <th>Action</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(item, i) in purchase" :key="i">
          <td> {{ item.date }}</td>
          <td> {{ item.bill_number }}</td>
          <td class="text-right"> {{ item.bill_amount }}</td>
          <td> {{ item.party_name }}</td>
          <td>
            <button class="btn btn-secondary btn-sm"
                    @click="goToPrint(item.id, 1)"
                    style="cursor: pointer; margin-left: 10px"
            >
              <i class="fas fa-print"></i>
            </button>
            <button class="btn btn-danger btn-sm p-0"
                    @click="goToReturn(item.id)"
                    style="cursor: pointer; margin-left: 10px"
                    v-if="item.status === 'active'"
            >
              <i class="far fa-window-close" style="font-size: 1.3em; margin: 5px 10px"></i>
            </button>
            <button class="btn btn-danger btn-sm"
                    @click="goToReturn(item.id, true)"
                    style="cursor: pointer; margin-left: 10px"
                    v-if="item.status !== 'returned'"
            >
              <i class="fas fa-undo-alt"></i>
            </button>
            <button v-if="item.sale_return_masters.length > 0"
                    class="btn btn-primary btn-sm"
                    @click="goToPrintReturn(item.sale_return_masters)"
                    style="cursor: pointer; margin-left: 10px"
            >
              <i class="fas fa-print"></i>
            </button>
          </td>
        </tr>

        </tbody>
      </table>
      <p v-if="!purchase.length" class="text-center mt-5">No data</p>
    </div>
    <SaleReturnPrint
      v-if="store.state.isModalOpenTwo"
      :saleReturnData="saleReturnData"
      :companyInfo="companyInfo"
      billType="electronic_invoice"
    />
  </div>
</template>

<style scoped>
.btn-challan {
  background-color: #249024 !important;
}
</style>

<script>
import figureFormatter from '@/services/utils/figureFormatter';
import handlePurchase from "@/services/modules/purchase";
import pdfPrinter from '@/services/utils/pdfPrinter';
import handleCompany from "@/services/modules/company";
import handleBarcode from "@/services/modules/barcode";
import { useStore } from "vuex";
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import handleHospital from '@/services/modules/hospital'
import pdfPrinterHelper from "@/services/utils/electronic-invoice/pdfPrinterHelper";
import SaleReturnPrint from "@/components/molecule/company/hospital/SaleReturnPrint.vue";
import hospitalPosPdfPrinter from '@/services/utils/hospitalPosPdfPrinter';

export default {
  components: {SaleReturnPrint},
  data() {
    return{
      companyInfo: {},
      invoice: {},
      barcodeQuery: '',
      barcode: '',
      user: {},
      qrcode: '',
      invoiceNotes: [],
      saleReturnData: [],
      customizationPdfFields: []
    }
  },
  props: {
    purchase: Array,
    route_name: {
      type: String,
      default: 'purchase-bill-edit'
    },
  },
  setup() {

    const { generatePdf } = pdfPrinterHelper();
    const {commaFormat} = figureFormatter()
    const { fetchSalesBill } = handlePurchase();
    const {fetchCompanyInfo, fetchActiveCustomizationField} = handleCompany();
    const { exportToPDF } = pdfPrinter();
    const { fetchBarcode } = handleBarcode();
    const store = useStore();
    const { notesByType } = handleHospital()
    const route = useRoute();
    const { exportToPDF: exportToPosPDF } = hospitalPosPdfPrinter();

    const isSupershopPosList = computed(() =>
      route.path.includes('supershop-pos-list') || route.path.includes('pos-invoice')
    )

    return {
      commaFormat,
      fetchSalesBill,
      exportToPDF,
      fetchCompanyInfo,
      fetchBarcode,
      store,
      notesByType,
      generatePdf,
      isSupershopPosList,
      fetchActiveCustomizationField,
      exportToPosPDF
    }
  },
  mounted() {
    this.fetchCompanyInfo(this.$route.params.companyId).then( (res) => {
      this.companyInfo = res.data;
    }).catch((error) => {
      console.log(error);
    });

    this.getInvoiceNotes();

    this.user = this.store.state.user.user

    if(this.isSupershopPosList) {
      this.getActiveFiledCustomization();
    }
  },
  methods: {
    async getInvoiceNotes () {
      const companyQuery = `?company_id=${this.$route.params.companyId}&show_default_only=1`;
      await this.notesByType(companyQuery, "invoice_terms").then((res) => {
        if(! res.status) return;
        this.invoiceNotes = res.data.filter((item) => item.full_desc);
      })
    },
    goToEdit(id) {
      let dynamicKeyName = (this.route_name === 'purchase-bill-edit') ? 'purchaseId' : 'salesId'
      let param = {
        companyId: this.$route.params.companyId,
        moduleId: this.$route.params.moduleId,
        menuId: this.$route.params.menuId,
        pageId: this.$route.params.pageId,
      }
      param[dynamicKeyName] = id;
      this.$router.push({
        name: this.route_name,
        params: param,
        query: this.$route.query
      })
    },
    async goToPrint(id, btnFunc) {
      try {
        const user = this.store.state.user.user;
        const companyQuery = `?company_id=${this.$route.params.companyId}`;
        const posPrint =
          this.isSupershopPosList &&
          this.customizationPdfFields &&
          this.customizationPdfFields.heading_left_pos_print;
      
        // Fetch bill
        const res = await this.fetchSalesBill(id, companyQuery);
        if (!res.status) return;
      
        this.invoice = res.data;

        if (posPrint) {
          this.exportToPosPDF(this.companyInfo, this.invoice);
          return;
        }

        let qrcodeData = JSON.stringify({
          ref_no: this.invoice.bill_number,
          ref_date: this.invoice.date,
          created_by: this.invoice.created_by_name,
          created_date_time: this.formatDate(new Date()),
        });
      
        this.barcodeQuery = `?code=${this.invoice.bill_number}&qrcode=${qrcodeData}`;
      
        const barcodeResult = await this.fetchBarcode(this.barcodeQuery);
        this.barcode = barcodeResult.barcode;
        this.qrcode = barcodeResult.qrcode;
      
        await this.exportToPDF(
          this.companyInfo,
          this.invoice,
          this.barcode,
          this.qrcode,
          user.name,
          1
        );
      } catch (err) {
        console.log("Something went wrong");
      }
    },

    formatDate(date) {
      var formattedDate = date.toISOString().split('T')[0];
      var hours = date.getHours();
      var minutes = date.getMinutes();
      var amOrPm = hours >= 12 ? 'PM' : 'AM';
      hours = hours % 12 || 12;
      var formattedTime = hours + ':' + (minutes < 10 ? '0' : '') + minutes + ' ' + amOrPm;

      return this.formatToDdMmYy(formattedDate) + ' ' + formattedTime
    },
    formatToDdMmYy(date) {
      var dat = date.split('-');
      return `${dat[2]}-${dat[1]}-${dat[0]}`;
    },
    goToReturn(id, isPartial = false) {
      let params = {
        companyId: this.$route.params.companyId,
        moduleId: this.$route.params.moduleId,
        menuId: this.$route.params.menuId,
        pageId: this.$route.params.pageId,
        invoiceId: id
      }

      let query = {
        ...this.$route.query,
        redirect_route: this.$route.query.redirect_route || (this.isSupershopPosList ? "pos-invoice" : "invoice-electronics-list"),
      };

      if (this.isSupershopPosList) {
        query.sale_type = 'pos_invoice';
      }

      this.$router.push({
        name: this.getRouteName(isPartial),
        params,
        query: query
      })
    },
    getRouteName(isPartial) {
      if(this.isSupershopPosList) {
        return isPartial ? "invoice-return-supershop-partial" : "invoice-return-supershop";
      }

      return isPartial ? "invoice-return-electronics-partial" :  "invoice-return-electronics"
    },
    goToPrintReturn(data) {
      this.saleReturnData = data;
      this.store.state.isModalOpenTwo = true;
    },
    async getActiveFiledCustomization () {
      const companyQuery = `?company_id=${this.$route.params.companyId}&customization_type=pdf&type=supershop_pos_pdf`;
      const res = await this.fetchActiveCustomizationField(companyQuery);
      this.customizationPdfFields = res.data;
    }
  }
}
</script>
